import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Container from '../components/Container';

import { CogIcon } from "@heroicons/react/outline";
import { TextField } from "UI/Form";
import Card from "UI/Card";
import Heading from "UI/Heading";
import Button from "UI/Button";

import { default as validateChangePasswordForm } from "Data/users/UserValidations";
import Form from "Components/Form/Form";

import * as UserActions from "Data/users/UserActions";

class ProfileSettingsController extends React.Component
{
    state = {
        changingPassword: false,
        error: false
    };

    static propTypes = {
        changePassword: PropTypes.func.isRequired
    };

    handleCreate = (data) => {
        this.setState({changingPassword: true});

        this.props.changePassword(
            data.password,
            data.new_password
        ).then(() => {
            this.setState({changingPassword: false});
        });
    };

    render()
    {
        return <Container>

            <Heading
                title={<div className='flex'><CogIcon className='w-7 mr-3' /> User settings </div>}
                description='Change your profile information.'
                />

            <Form validate={validateChangePasswordForm} onSubmit={this.handleCreate}>
                {
                    (data, onChange, validation) => <fieldset disabled={this.state.changingPassword}>
                        <Card className="space-y-8 divide-y divide-y-gray-200">

                            <div className="grid grid-cols-1 gap-y-6 sm:grid-cols-6 sm:gap-x-6">
                                <div className="sm:col-span-5">
                                    <h2 className="text-xl font-medium text-gray-700">Change Password</h2>
                                    <p className="mt-1 text-sm text-gray-500">
                                        Update your password.
                                    </p>
                                </div>

                                <div className="sm:col-span-3 lg:col-span-2 space-y-4">
                                    <div>
                                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                            Current Password
                                        </label>
                                        <TextField
                                            type="password"
                                            name="password"
                                            id="password"
                                            onChange={onChange('password')}
                                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-gray-700 sm:text-sm focus:ring-blue-500 focus:border-blue-500"
                                            error={validation.hasErrors('password')}
                                            help={validation.getErrors('password')[0]}
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="new_password" className="block text-sm font-medium text-gray-700">
                                            New Password
                                        </label>
                                        <TextField
                                            type="password"
                                            name="new_password"
                                            id="new_password"
                                            onChange={onChange('new_password')}
                                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-gray-700 sm:text-sm focus:ring-blue-500 focus:border-blue-500"
                                            error={validation.hasErrors('new_password')}
                                            help={validation.getErrors('new_password')[0]}
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="confirm_password" className="block text-sm font-medium text-gray-700">
                                            Confirm New Password
                                        </label>
                                        <TextField
                                            type="password"
                                            name="confirm_password"
                                            id="confirm_password"
                                            onChange={onChange('confirm_password')}
                                            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-gray-700 sm:text-sm focus:ring-blue-500 focus:border-blue-500"
                                            error={validation.hasErrors('confirm_password')}
                                            help={validation.getErrors('confirm_password')[0]}
                                        />
                                    </div>

                                </div>
                            </div>

                            <div className="pt-8 flex justify-end">
                                <Button type='primary' className='ml-3'>Save</Button>
                            </div>
                        </Card>
                    </fieldset>
                }
            </Form>

        </Container>;
    }
}




const mapStateToProps = (state, ownProps) => ({

});

const mapDispatchToProps = {
    changePassword: UserActions.changePassword
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProfileSettingsController);
